import { RedemptionStatusEnum } from 'common/enums/RedemptionStatusEnum'
import { ITicket } from 'store/afterSales/types'

interface Props {
  tickets: ITicket[]
}

export const useFilterTicketsToRedeem = ({ tickets }: Props) => {
  const filterTicketsToRedeem = tickets.filter(
    (ticket) => ticket.redemptionStatus === RedemptionStatusEnum.READY_TO_RELEASE,
  )

  const countTickets = filterTicketsToRedeem.length
  const transactionAmount = countTickets > 0 ? filterTicketsToRedeem[0].redemptionAmount : 0

  return { tickets: filterTicketsToRedeem, transactions: countTickets, transactionAmount }
}
